import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, Divider } from 'antd'
import { Chart, Interval, Tooltip } from 'bizcharts'
import { req_single_cms_learnmap_completed_ability_trend } from '../../api'

class CoursemapStudentAbilityChartModal extends Component {
    // 基礎通用參數 //////////////////////////////////////////////   
    static propTypes = {
        trend: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        title: null,
        item: {},
        items: [],
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.init()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_init_items = async (selector) => {
        const { token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_learnmap_completed_ability_trend(selector, token)
        if (result) {
            if (result.total > 0) {
                const rows = result.data
                let array = []
                rows.forEach(row => {
                    let item = {
                        year: row.grade + '年級第' + row.semester + '學期',
                        value: parseFloat((Math.sqrt(row.getAbilityCompletedValue) * 10).toFixed(2))
                    }
                    array.push(item)
                });
                const items = array
                console.log(items)
                this.setState({ loading: false, items })
            } else {
                this.setState({ loading: false })
            }
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    init = () => {
        const { AbilityName } = this.props.trend
        const title = AbilityName
        this.setState({ title })
        this.api_init_items(this.props.trend)
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { items, title } = this.state
        return (
            <Card>
                <Divider orientation="left" plain ><i className="fas fa-sitemap"></i> {title}</Divider>
                <Chart height={400} autoFit data={items} interactions={['active-region']} padding={[30, 30, 30, 50]} >
                    <Interval position="year*value" />
                    <Tooltip shared />
                </Chart>
            </Card>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentAbilityChartModal)